export function removeDuplicates(arr, getValue = (v) => v) {
  const seen = {};
  return arr.filter(item => {
    if (seen[getValue(item)]) {
      return false;
    }
    seen[getValue(item)] = true;
    return true;
  });
}

export function removeItem(arr, item) {
  const index = arr.indexOf(item);
  if (index !== -1) {
    const result = [...arr];
    result.splice(index, 1);
    return result;
  }
  return arr;
}

export const intersection = (arr1, arr2) => {
  return arr1.filter(x => arr2.includes(x));
};

export const objectToArray = (obj) => {
  if (!obj) {
    return [];
  }
  // Object.keys has better browser support than Object.values
  return Object.keys(obj).map((el) => {
    return obj[el];
  })
}